import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HEADER_OFFSET_PX = 96;
const MAX_ATTEMPTS = 10;
const RETRY_INTERVAL_MS = 50;

export default function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    const { hash } = location;

    const scrollToId = (id: string) => {
      const el = document.getElementById(id);
      if (!el) return false;

      // Use requestAnimationFrame to batch layout read with render cycle
      requestAnimationFrame(() => {
        const y = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET_PX;
        window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
      });
      return true;
    };

    if (hash) {
      const id = decodeURIComponent(hash.replace(/^#/, ""));

      // Try immediately
      if (scrollToId(id)) return;

      // If element not found, retry multiple times (for route transitions)
      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (scrollToId(id) || attempts >= MAX_ATTEMPTS) {
          clearInterval(interval);
        }
      }, RETRY_INTERVAL_MS);

      return () => clearInterval(interval);
    }

    // No hash: default scroll-to-top on navigation
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname, location.hash]);

  return null;
}
